import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const CustomDialogCloseButton = styled(Button)`
  position: absolute;
  right: 0.5rem /* 8/16 */;
  top: 0.5rem /* 8/16 */;
  background: transparent;
  border: none;
`;
